import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/auth';

export default function NavBar() {
    const { user, login, logout } = useAuth();


    return (

        <nav className="navbar bg-light ">
            <div className="container-fluid">

                <span className="navbar-brand">
                    <div>welcome {user?.email}</div>
                </span>

                <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                    <div className="offcanvas-header">
                        {/* <h5 className="offcanvas-title" id="offcanvasNavbarLabel">Close</h5> */}
                        <button type="button" className="align-items-center" data-bs-dismiss="offcanvas" aria-label="Close">

                            <span className="btn-close btn-close-black m-10"></span>

                        </button>
                    </div>

                    <div className="offcanvas-body">
                        <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                            <li className="nav-item nav-link active">

                                <Link to="/">Home</Link>

                            </li>


                            {/* <li className="nav-item nav-link active">

                                <Link to="/about">About</Link>

                            </li> */}

                            <li className="nav-item nav-link active">

                                <button onClick={logout}>
                                    <a >Log out</a>
                                </button>

                            </li>
                        </ul>

                    </div>
                </div >
            </div >
        </nav >


    )
}
